import { render, staticRenderFns } from "./FixedHeader.vue?vue&type=template&id=05b33419&scoped=true&"
import script from "./FixedHeader.vue?vue&type=script&lang=ts&"
export * from "./FixedHeader.vue?vue&type=script&lang=ts&"
import style0 from "./FixedHeader.vue?vue&type=style&index=0&id=05b33419&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b33419",
  null
  
)

export default component.exports